import { advIntervalAuctionsBreadcrumbs } from '@revbox/localization'
import React from 'react'

function IntervalAuctionCellRenderer({ value, language }) {
    const now = new Date()
    const target = new Date(value)
    if (isNaN(target.getTime()) || now.getTime() > target.getTime()) {
        return <div> {advIntervalAuctionsBreadcrumbs[language].closedAuctionTitle}</div>
    }

    const diff = target.getTime() - now.getTime()
    const hours = Math.floor(diff / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const days = Math.floor(hours / 24)
    const remainingHours = hours % 24
    const remainingMinutes = minutes % 60
    return (
        <div>
            {days}d {remainingHours}h {remainingMinutes}m
        </div>
    )
}

export default IntervalAuctionCellRenderer
